import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

// Check for a new service worker every minute while the tab is visible. Fast
// enough to feel "live" during testing, light enough not to spam the server.
const CHECK_INTERVAL_MS = 60_000;

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      const tick = () => {
        if (document.visibilityState === 'visible') {
          registration.update().catch(() => {
            // Network blip or offline — try again next tick.
          });
        }
      };
      const id = setInterval(tick, CHECK_INTERVAL_MS);
      document.addEventListener('visibilitychange', tick);
      return () => {
        clearInterval(id);
        document.removeEventListener('visibilitychange', tick);
      };
    },
  });

  // Restore from the registered cleanup if React re-runs the callback.
  useEffect(() => undefined, []);

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-3 z-50 max-w-md mx-auto bg-brand-orange text-white rounded-2xl shadow-card px-4 py-3 flex items-center gap-3"
      style={{ top: 'calc(env(safe-area-inset-top) + 0.75rem)' }}
    >
      <div className="flex-1">
        <p className="font-semibold text-sm">Mise à jour disponible</p>
        <p className="text-xs opacity-90">Touche pour charger la dernière version.</p>
      </div>
      <button
        type="button"
        onClick={() => void updateServiceWorker(true)}
        className="rounded-pill bg-white text-brand-orange font-semibold text-sm px-3 py-1.5 shrink-0"
      >
        Mettre à jour
      </button>
      <button
        type="button"
        onClick={() => setNeedRefresh(false)}
        aria-label="Plus tard"
        className="text-white/80 px-1 text-lg leading-none"
      >
        ×
      </button>
    </div>
  );
}
